@if (ready ) {
  <router-outlet></router-outlet>
} @else {
  <app-loading-error [boolean]="true" [message]="'waiting-for-load' | translate"></app-loading-error>
}

